import React, { useEffect, useMemo, useRef, useState } from "react";
import cn from "classnames";
import { Skeleton } from "@material-ui/lab";
import type { FC } from "react";
import { useStyles } from "./GradientLoader.styles";
import type { IGradientLoaderProps } from "./GradientLoader.types";
import { useDebounce } from "../../hooks";

export const GradientLoader: FC<IGradientLoaderProps> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { width, height } = props;
  useEffect(() => {
    if (ref.current?.parentElement) {
      let parentPosition = ref.current.parentElement.style.position;
      let parentWidth = ref.current.parentElement.style.width;
      let parentHeight = ref.current.parentElement.style.height;
      
      ref.current.parentElement.style.position = "relative";
      if (width) {
        ref.current.parentElement.style.width = String(width);
      }
      if (height) {
        ref.current.parentElement.style.height = String(height);
      }

      return () => {
        if (ref.current?.parentElement) {
          ref.current.parentElement.style.position = parentPosition;
          ref.current.parentElement.style.width = parentWidth;
          ref.current.parentElement.style.height = parentHeight;
        }
      };
    }
  }, []);

  const symbol = useMemo(() => Symbol(), []);
  const classes = useStyles();
  const { debounce } = useDebounce();
  const { open, ...skeletonProps } = props;
  const [stateOpen, setStateOpen] = useState(open);
  useEffect(() => {
    if (open === false) {
      debounce(() => setStateOpen(open), 200, symbol);
    } else {
      setStateOpen(open);
    }
  }, [open, symbol, debounce]);

  if (stateOpen === false) {
    return null;
  }

  return (
    <div ref={ref} className={classes.container}>
      <Skeleton className={cn(classes.root, { [classes.hidden]: open === false })} {...skeletonProps} />
    </div>
  );
};
